import { enUS, es, fr } from 'date-fns/locale'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi, { HttpBackendOptions } from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { API_PUBLIC_URL, APIM_SUBSCRIPTION_KEY } from '@/config/env'

const getLocaleObj = (lang: string) => {
  switch (lang) {
    case 'fr':
      return fr
    case 'es':
      return es
    default:
      return enUS
  }
}

export const getCountryLocaleObj = (lang: string) => {
  const regionName = new Intl.DisplayNames([lang], { type: 'region' })
  return {
    nameOf: (country: string) => regionName.of(country),
  }
}

const langDetectorOptions = {
  // order and from where user language should be detected
  order: ['cookie', 'localStorage', 'navigator'],

  // keys or params to lookup language from
  lookupCookie: 'locale',
  lookupLocalStorage: 'locale',

  // cache user language on
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  // only detect languages that are in the whitelist
  checkWhitelist: true,
}

i18next
  .use(HttpApi)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init<HttpBackendOptions>({
    fallbackLng: ['en', 'fr'],
    supportedLngs: ['fr', 'en', 'es'],
    // Allow regional variants (e.g. "es-CO", "en-US") to resolve to their base language
    // instead of falling back to `fallbackLng` when not explicitly listed in supportedLngs.
    nonExplicitSupportedLngs: true,
    detection: langDetectorOptions,
    backend: {
      loadPath: (_lngs: string[], nss: string[]) =>
        nss.includes('factory') ? `${API_PUBLIC_URL}/metadata/locales/{{lng}}.json` : '/locales/{{ns}}/{{lng}}.json',
      customHeaders: APIM_SUBSCRIPTION_KEY ? { 'Ocp-Apim-Subscription-Key': APIM_SUBSCRIPTION_KEY } : undefined,
      requestOptions: {
        cache: 'no-store',
      },
      withCredentials: true,
    },
    ns: ['errors'], // Preload errors namespace for handleApiError (called outside React hooks)
    react: {
      transKeepBasicHtmlNodesFor: ['b', 'br', 'strong', 'i', 'ul', 'ol', 'li', 'p'],
    },
  })

export { getLocaleObj, i18next }
